const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+About+Me+Review+Questions+API

function getAboutMeReviewQuestions(productId) {
    let url = '/api/util/aboutMeQuestions?productId=' + productId;
    return ufeApi.makeRequest(url).
        then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = getAboutMeReviewQuestions;
